// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1_31H","dragIcon":"Choice_dragIcon__2BAQM","left":"Choice_left__1K8NV","input":"Choice_input__oxR5v"};